import React from "react";
import moment from "moment";
import CustomDropdown from "../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";
import ChartIndexSelector from "../Dashboard/Charts/ChartsOptionsSidebar/ChartIndexSelector";

const FBPageSelector = ({ fbSelectedPageIds, setSelectedFbPage, selectedFbPage, widgetContainerRef }) => {
    let index = selectedFbPage.value;

    const handleFbPageChange = (d) => {
        let val = fbSelectedPageIds.find((elem) => elem.value == d);
        setSelectedFbPage(val);
    };

    return (
        <div className="chart-item-name">
            <ChartIndexSelector
                isFbPage
                currentName={selectedFbPage.label}
                currentIndex={index}
                options={fbSelectedPageIds}
                onIndexChange={(e) => handleFbPageChange(e)}
                widgetContainerRef={widgetContainerRef}
            />
        </div>
    );
};

export default FBPageSelector;
